import styled from 'styled-components';
import * as React from 'react';
import IMPComponent from '../interfaces/IMPComponent';

export interface InfoWindowProps extends IMPComponent {
  children?: React.ReactNode;
}

const AllScreenContainer = styled.div`
  position: absolute;
  top: ${props => props.theme.sizes.headerHeight};
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  align-content: center;
  z-index: 100;
`;

const Overlay = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: ${props => props.theme.color.cerulean};
  opacity: 0.2;
`;

const Container = styled.div`
  width: 400px;
  height: auto;
  border-radius: 10px;
  padding: 30px;
  background-color: white;
  z-index: 101;
`;

export const AllScreenInfoWindow = ({ children }: InfoWindowProps) => {
  return (
    <AllScreenContainer>
      <Overlay />
      <Container>{children}</Container>
    </AllScreenContainer>
  );
};



// WEBPACK FOOTER //
// ./src/components/AllScreenInfoWindow/AllScreenInfoWindow.tsx